export default __webpack_public_path__ + "static/media/visit.4d69e7a8.png";